import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import DashboardChartMapContainer from './components/DashboardChartMapContainer';
import * as actions from './action';
import * as c from './constant';

function TransactionsContainer({ totalStats, getTotalStats }) {
  const returnBillsData = () => {
    const data = _.get(
      totalStats,
      'item.total_mobile_load_transaction_per_status'
    );

    return {
      label: 'Bills',
      total: _.get(totalStats, 'item.total', 0),
      list: [
        {
          label: 'Pending',
          value: _.get(data, 'PENDING', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Processed',
          value: _.get(data, 'PROCESSED', 0),
          borderClassName: 'paid',
        },
        {
          label: 'Received',
          value: _.get(data, 'RECEIVED', 0),
          borderClassName: 'paid',
        },
        {
          label: 'Waiting For Payment',
          value: _.get(data, 'WAITING FOR PAYMENT', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Payment Failed',
          value: _.get(data, 'PAYMENT FAILED', 0),
          borderClassName: 'failed',
        },
      ],
    };
  };

  useEffect(() => {
    getTotalStats();
  }, []);

  return (
    <div className="container-fluid mb-3">
      <div className="row">
        <div className="col-4 pl-0">
          <DashboardListCard data={returnBillsData()} className="mb-2" />
        </div>
        <div className="col-8 pr-0">
          <DashboardChartMapContainer />
        </div>
      </div>
    </div>
  );
}

TransactionsContainer.propTypes = {
  totalStats: PropTypes.instanceOf(Object).isRequired,
  getTotalStats: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  totalStats: _.get(api, `${c.GET_TOTAL_STATS}`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TransactionsContainer);
